import { Component, OnInit } from '@angular/core';
import { slideInOutAnimation } from 'src/app/route-animations';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss'],
  animations: [slideInOutAnimation],
  host: { '[@slideInOutAnimation]': '' },
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class ThankYouComponent implements OnInit {

  constructor() { 
    localStorage.setItem('state', '/bedankt');
  }

  public ngOnInit(): void {
    window.scroll(0,0);
    localStorage.clear();
  }

  public close() {
    window.close();
    window.location.href = "https://autoverkooppartner.nl"
  }
}
